import { render, staticRenderFns } from "./orderManagerPos.vue?vue&type=template&id=70196cca&scoped=true&"
import script from "./orderManagerPos.vue?vue&type=script&lang=js&"
export * from "./orderManagerPos.vue?vue&type=script&lang=js&"
import style0 from "./orderManagerPos.vue?vue&type=style&index=0&id=70196cca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70196cca",
  null
  
)

export default component.exports